"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DateFormatter = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/DateFormatter"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles formatting of dates.
 *
 * Deprecated, use @ikea-aoa/ikea-shared-utils/lib/util/DateFormatter
 */
var DateFormatterWrapper = /*#__PURE__*/function () {
  function DateFormatterWrapper() {
    _classCallCheck(this, DateFormatterWrapper);
  }

  _createClass(DateFormatterWrapper, null, [{
    key: "isoStringToDate",

    /**
     * Formats a date.
     *
     * @deprecated
     * @param {string} dateString Date string.
     * @returns {Date} Formatted date.
     */
    value: function isoStringToDate(dateString) {
      _Console.default.warn('DateFormatter has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/DateFormatter" instead.');

      return _DateFormatter.default.isoStringToDate(dateString);
    }
    /**
     * Formats a date object to a date string.
     *
     * @deprecated
     * @param {Date|string|number} date Date object, or string/number to pass into the date constructor.
     * @param {string} [format] Format to use. Default is "YYYY-MM-DD".
     * @returns {string} Formatted date.
     */

  }, {
    key: "dateToString",
    value: function dateToString(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

      _Console.default.warn('DateFormatter has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/DateFormatter" instead.');

      return _DateFormatter.default.dateToString(date, format);
    }
  }]);

  return DateFormatterWrapper;
}();

exports.default = DateFormatterWrapper;